import { z } from 'zod';

// 주문번호 형식: 영문 2자리 + 숫자 6자리 (예: KT482913)
const ORDER_NO_PATTERN = /^[A-Z]{2}\d{6}$/;
// 이전 형식 (ORD- + 숫자) 주문도 계속 조회되도록 허용
const LEGACY_ORDER_NO_PATTERN = /^ORD-?(\d{6,20})$/;

export const lookupFormSchema = z.object({
  // 필수: 주문번호
  orderNo: z
    .string()
    .trim()
    .min(1, '주문번호를 입력해주세요.')
    .refine((v) => {
      const normalized = normalizeOrderNo(v);
      return ORDER_NO_PATTERN.test(normalized) || LEGACY_ORDER_NO_PATTERN.test(normalized);
    }, '주문번호를 확인해주세요. (영문 2자리 + 숫자 6자리)'),
  name: z.string().min(1, '성함을 입력해주세요.'),
  phone1: z.string().regex(/^01[0-9]$/, '연락처를 확인해주세요.'),
  phone2: z.string().regex(/^\d{3,4}$/, '연락처를 확인해주세요.'),
  phone3: z.string().regex(/^\d{4}$/, '연락처를 확인해주세요.'),
  password: z.string().min(1, '비밀번호를 입력해주세요.'),
});

export type LookupFormSchema = z.infer<typeof lookupFormSchema>;

export function joinLookupPhone(values: Pick<LookupFormSchema, 'phone1' | 'phone2' | 'phone3'>): string {
  return `${values.phone1}${values.phone2}${values.phone3}`;
}

// 입력값 정리: 공백 제거 + 대문자로 (소문자로 입력해도 처리)
function normalizeOrderNo(value: string): string {
  return value.trim().replace(/\s/g, '').toUpperCase();
}

// 서버로 보낼 주문번호 (이전 형식은 'ORD-' + 숫자로 맞춤)
export function toOrderNo(value: string): string {
  const normalized = normalizeOrderNo(value);
  const legacy = normalized.match(LEGACY_ORDER_NO_PATTERN);
  return legacy ? `ORD-${legacy[1]}` : normalized;
}

export const ORDER_NO_EXAMPLE = 'KT482913';
